import React from 'react'
import Header from './Header';
import Info from './Info';
import Product from './Product';
import Report from './Report';
import Footer from './Footer';
import { product , dataInvoice, location , paymentInfo , companyInfo} from './modal';
import './Style/Invoice.css'

function Invoice() {

  let total = product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0)
  let discount = (product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0) * product.discount/100)  
  let lastPrice = total - discount

  var today = new Date();
  var date = today.getFullYear()+' - '+(today.getMonth()+1)+' - '+today.getDate();


  return <div className='invoice'>
      <Header />
      <Info data={dataInvoice} location={location} todayDate={date} info={companyInfo}/>
      <Product data={product.info}/>
      <Report 
        data={paymentInfo} 
        subTotal={total}
        discount={discount}
        lastPrice={lastPrice}
        product={product}
        />
      <Footer info={companyInfo} todayDate={date}/>
  </div>
}

export default Invoice